
    import '/home/ec2-user/Youlify-Design/components/_util/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/_util/index.zh-CN.md?type=demo')
};